//@flow
import React from 'react';
import Sidebar from '../../MobileMenu/components/Sidebar.react';
import MobileMenu from '../../MobileMenu/components/MobileMenu.react';
import CartActions from '../../Actions/cart';
import CartPreview from './CartPreview.react';
import UrlData from '../../Utils/url-data';

import type CategoryModel from '../../Stores/MemberCategories/categoryModel';
import type CustomerModel from '../../Stores/Customer/customerModel';
import type QuoteItemsCollection from '../../Stores/Quote/quoteItemsCollection';
import type QuoteTotalsModel from '../../Stores/Quote/quoteTotalsModel';
import type QuoteModel from '../../Stores/Quote/quoteModel';
import type MembershipModel from '../../Stores/Membership/membershipModel';
import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';
import type ProductsCollection from '../../Stores/Products/productsCollection';
import type StockCollection from '../../Stores/Stock/stockCollection';

type Props = {
  loggedIn:boolean,
  customer:CustomerModel,
  handleLoginClick:() => void,
  isMenuOpen:boolean,
  categories:CategoryModel[],
  products:ProductsCollection,
  quoteItems:QuoteItemsCollection,
  mobileOnSetOpen:() => void,
  children?:React$Node,
  showCategories:boolean,
  isCartOpen:boolean,
  quoteTotals:QuoteTotalsModel,
  quote:QuoteModel,
  membership:MembershipModel,
  isIOS:boolean,
  membershipPlan:MembershipPlanModel,
  hasSub:boolean,
  showGiftUI:boolean,
  stock:StockCollection,
};

function _getSidebarContent(props:Props) {
  const hidePromoCodeInput = UrlData.getShouldHidePromoCodeInput();
  const hideMsrpToggle = UrlData.getShouldHideMsrpToggle();
  const hideMembershipOption = UrlData.getShouldHideCheckoutMembershipOption();
  return (
    <CartPreview
      quoteTotals={props.quoteTotals}
      quoteItems={props.quoteItems}
      products={props.products}
      membership={props.membership}
      quote={props.quote}
      isCartOpen={props.isCartOpen}
      isIOS={props.isIOS}
      membershipPlan={props.membershipPlan}
      customer={props.customer}
      showGiftUI={props.showGiftUI}
      hidePromoCodeInput={hidePromoCodeInput}
      hideMsrpToggle={hideMsrpToggle}
      hideMembershipOption={hideMembershipOption}
      stock={props.stock}
    />
  );
}

function _closeCartPreview() {
  CartActions.closeCartPreview();
}

/* because of the way the sidebar component is constructed, the mobile menu
sidebar is passed to the cartpreview sidebar as a prop so that both can be rendered
at the same time */
export default function CartPreviewWrapper(props:Props) {
  return (
    <Sidebar
      sidebar={_getSidebarContent(props)}
      pullRight={true}
      open={props.isCartOpen}
      onSetOpen={_closeCartPreview}
    >
      <MobileMenu
        loggedIn={props.loggedIn}
        customer={props.customer}
        handleLoginClick={props.handleLoginClick}
        open={props.isMenuOpen}
        categories={props.categories}
        onSetOpen={props.mobileOnSetOpen}
        showCategories={props.showCategories}
        hasSub={props.hasSub}
      >
        {props.children}
      </MobileMenu>
    </Sidebar>
  );
}
